import React from 'react';
import { externalUrls } from '../../ui-toolkit/rest/ExternalUrlFactory';

export const SpruceHelpInlineLinkTW: React.FC = () => {
  return (
    <a
      className={'-mb-0.5 inline-block cursor-pointer text-left hover:underline focus:underline'}
      href={externalUrls.urlFor.spruceHelpLinkUrl()}
      target={`_blank`}
    >
      click here
    </a>
  );
};
